
import { AuthParameters } from 'app/routes/auth/core'

const auth: AuthParameters[] = [
]

export default auth